import axiosInstance from "../Utils/axiosInstance";
import { PoliticSpaceApi } from "../Constants/api";

export const getPoliticSpacesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${PoliticSpaceApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
